import React from "react";
import { Dialog } from "@blueprintjs/core";
import styles from "./ProgramSettings.module.scss";
import { Icon } from "../../../atoms/Icon";

export default function BrandPagePreview({
  programHighlight,
  programFeatures,
  isOpen,
  onDismiss
}) {
  return (
    <Dialog isOpen={isOpen} className={styles.dialog}>
      <Icon name="cross" onClick={onDismiss} className={styles.closePreview} />
      <div className={styles.previewBody}>
        <div className={styles.descriptionContainer}>
          <p className={styles.brandDesc}>{programHighlight}</p>
          <a>www.brandwebsite.com</a>
        </div>
        <div className={styles.offerContainer}>
          <div className={styles.offerDetails}>
            <h4 className={styles.heading}>Offer Details</h4>
            <ul className={styles.checkListItems}>
              {programFeatures.map((feature) => (
                <li>
                  <Icon name="tick-circle" />
                  {feature}
                </li>
              ))}
            </ul>
            <button className={styles.applyButton}>
              Apply for this Opportunity
            </button>
            <p className={styles.signUpText}>
              Already have a Video Squirrel account?
              <a> Sign up</a>
            </p>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
